module.exports = __webpack_public_path__ + "img/py.6a028873.svg";